<template>
    <div v-if="showChanges && changes != null && changes.length > 0" class="row" :style="pageMode ? { border: '2px dashed #aaaaaa' } : { 'border-top': '2px dashed #aaaaaa' }" style="margin-top: 5px; display: flex; justify-content: center">
        <!--
        - {{ JSON.stringify(changes) }} -- {{ changes.length }} - {{ showChanges && changes != null && changes.length > 0 }} - {{ showChanges }} - {{ changes != null }} - {{ changes.length > 0 }} -
        -->
        <button v-show="!show" class="btn btn-link btn-sm col-12" @click.prevent="show = true">Show {{ pageMode ? "Page " : "" }} Changes</button>
        <div class="col-12" style="padding: 0.75rem 1.25rem; margin-bottom: 0" v-show="show">
            <div style="display: flex; justify-content: space-between; align-items: flex-start">
                <h3 class="h5">{{ pageMode ? "Page " : "" }}Settings Changes</h3>
                <button style="padding-top: 0" class="btn btn-link btn-sm" @click.prevent="show = false">Hide</button>
            </div>
            <ul class="list-group list-group-flush">
                <li v-for="change in changes" class="list-group-item">
                    <h4 class="h6">{{ change.key }}</h4>
                    <div><strong>Prior:</strong> {{ change.baseSetting }}</div>
                    <div><strong>Now:</strong> {{ change.currentSetting }}</div>
                </li>
            </ul>
        </div>
    </div>
</template>
<script lang="ts">
import { defineComponent, ref, computed } from "vue";
import { usePageStore } from "../pageState/store";
//import type { BaseElementDefBase } from "../elements/BaseElementDef";
interface Props {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    data: any; // TODO
    pageMode?: boolean; // TODO
}
export default defineComponent({
    props: ["data", "pageMode"],
    setup(props: Props) {
        const show = ref(false);

        const pageStore = usePageStore();

        const showChanges = computed(() => {
            return pageStore.showChanges;
        });
        const changes = computed(() => {
            return props.data.baseChanges;
        });

        return {
            show,
            showChanges,
            changes,
        };
    },
});
</script>
